document.addEventListener('DOMContentLoaded', function () {
  const volumeInput = document.getElementById('volume');
  const volumeToggle = document.getElementById('volumeToggle');
  const productSelect = document.getElementById('product');
  const productInfoDiv = document.getElementById('productInfo');
  const errorMessageDiv = document.getElementById('errorMessage');
  const calculateButton = document.getElementById('calculateButton');

  if (
    !volumeInput ||
    !volumeToggle ||
    !productSelect ||
    !productInfoDiv ||
    !errorMessageDiv ||
    !calculateButton
  ) {
    console.error('Carbon calculator: required elements not found.');
    return;
  }

  function updateVolumePlaceholder() {
    volumeInput.placeholder = volumeToggle.checked
      ? 'Enter volume in liters'
      : 'Enter volume in gallons';
  }

  function clearMessages() {
    errorMessageDiv.style.display = 'none';
    errorMessageDiv.innerHTML = '';
    productInfoDiv.style.display = 'none';
    productInfoDiv.innerHTML = '';
  }

  function showError(message) {
    errorMessageDiv.style.display = 'block';
    errorMessageDiv.innerHTML = message;
  }

  function calculateCarbonDose() {
    clearMessages();

    const volume = parseFloat(volumeInput.value);
    const volumeUnit = volumeToggle.checked ? 'liters' : 'gallons';
    const k = parseFloat(productSelect.value);
    const selectedProduct = productSelect.options[productSelect.selectedIndex].text.split(' (')[0];

    let volumeGallons = volumeUnit === 'liters' ? volume / 3.785 : volume;

    if (isNaN(volumeGallons) || volumeGallons <= 0 || isNaN(k)) {
      showError('Please enter a valid positive volume.');
      return;
    }

    const doseTbsp = volumeGallons * k;
    const doseCups = doseTbsp / 16;
    const doseGrams = doseTbsp * 14.7868 * 0.5;

    let content = '';

    if (k === 0.32 && selectedProduct === 'Reef Genetics Carbon') {
      content = `
        <p>Reef Genetics Carbon is laboratory-grade, designed to clear cloudy water and remove organic contaminants with a phosphate-free, high-purity formula.</p>
        <ul>
          <li><span>Tablespoons:</span> ${doseTbsp.toFixed(2)}</li>
          <li><span>Cups:</span> ${doseCups.toFixed(2)}</li>
          <li><span>Grams:</span> ${doseGrams.toFixed(2)}</li>
        </ul>
      `;
    } else if (k === 0.1333) {
      content = `
        <p>Red Sea REEF-SPEC Carbon rapidly removes organic pollutants, ensuring crystal-clear water with optimal micro and macro pore structures for reef aquariums.</p>
        <ul>
          <li><span>Tablespoons:</span> ${doseTbsp.toFixed(2)}</li>
          <li><span>Cups:</span> ${doseCups.toFixed(2)}</li>
          <li><span>Grams:</span> ${doseGrams.toFixed(2)}</li>
        </ul>
      `;
    } else {
      content = `
        <p>Recommended carbon amount based on your selected product and system volume.</p>
        <ul>
          <li><span>Tablespoons:</span> ${doseTbsp.toFixed(2)}</li>
          <li><span>Cups:</span> ${doseCups.toFixed(2)}</li>
          <li><span>Grams:</span> ${doseGrams.toFixed(2)}</li>
        </ul>
      `;
    }

    productInfoDiv.style.display = 'block';
    productInfoDiv.innerHTML = content;
  }

  productSelect.addEventListener('change', function () {
    productInfoDiv.style.display = 'none';
    productInfoDiv.innerHTML = '';
    errorMessageDiv.style.display = 'none';
    errorMessageDiv.innerHTML = '';
  });

  volumeToggle.addEventListener('change', updateVolumePlaceholder);
  calculateButton.addEventListener('click', calculateCarbonDose);

  updateVolumePlaceholder();

  window.calculateCarbonDose = calculateCarbonDose;
});